import { render } from "./badge.vue?vue&type=template&id=5834ad25&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"

import "./badge.vue?vue&type=style&index=0&id=5834ad25&scoped=true&lang=css"

import exportComponent from "/home/buildsseatshopcom/builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5834ad25"]])

export default __exports__